var t=function(t){return"".concat(t.type,"-").concat(t.key)};export{t as g};
